import { get, post, remove} from "../common/http.services";

export function getOrderByCode(code: any, appContext: any, success: any, error: any) {
    return get(`/order/findbycode?code=${code}`, appContext, success, error);
}

export function searchOrder(searchData: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return post(`/order/search/?page=${pageNumber}&size=${pageSize}&sort=creationDate,desc`, searchData, appContext, success, error);
}

export function getOrderTrend(data: any, appContext: any, success: any, error: any) {
    return post(`/order/trend`, data, appContext, success, error);
}

export function searchStockList(searchData: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return post(`/order/stock/list/?page=${pageNumber}&size=${pageSize}`, searchData, appContext, success, error);
}

export function transferStock(data: any, appContext: any, success: any, error: any) {
    return post(`/order/stock/transfer`, data, appContext, success, error);
}

export function getInputCodeValues(data: any, appContext: any, success: any, error: any) {
    return post(`/order/stock/inputcode`, data, appContext, success, error);
}

export function searchStockLedger(searchData: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return post(`/order/stock/ledger/?page=${pageNumber}&size=${pageSize}`, searchData, appContext, success, error);
}

export function getNegativeLedger(appContext: any, success: any, error: any) {
    return get(`/order/stock/ledger/negative`, appContext, success, error);
}

export function getAllLedger(pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return get(`/order/stock/ledger/all?page=${pageNumber}&size=${pageSize}`, appContext, success, error);
}

export function getOrderByEnquiryCode(enquiryCode: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return get(`/order/findbyenquirycode/?enquiryCode=${enquiryCode}&page=${pageNumber}&size=${pageSize}&sort=creationDate,desc`, appContext, success, error);
}

export function getOrderByCostingCode(costingCode: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return get(`/order/findbycostingcode/?costingCode=${costingCode}&page=${pageNumber}&size=${pageSize}&sort=creationDate,desc`, appContext, success, error);
}

export function getOrderInfoByCostingCode(costingCode: any, appContext: any, success: any, error: any) {
    return get(`/order/getinfobycostingcode/?costingCode=${costingCode}`, appContext, success, error);
}

export function saveOrder(orderModel: any, appContext: any, success: any, error: any) {
    return post(`/order`, orderModel, appContext, success, error);
}

export function deleteOrder(orderId: any, appContext: any, success: any, error: any) {
    return remove(`/order/?orderId=${orderId}`, appContext, success, error);
}

export function getOrderById(id: any, appContext: any, success: any, error: any) {
    return get(`/order/findbyid?id=${id}`, appContext, success, error);
}

export function getPurchase(orderId: any, appContext: any, success: any, error: any) {
    return get(`/order/getpurchase?orderId=${orderId}`, appContext, success, error);
}

export function getProcessingData(orderId: any, searchText: any, appContext: any, success: any, error: any) {
    return get(`/order/getprocessingdata?orderId=${orderId}&searchText=${searchText}`, appContext, success, error);
}

export function getOrderProducts(orderId: any, appContext: any, success: any, error: any) {
    return get(`/order/getproducts?orderId=${orderId}`, appContext, success, error);
}

export function getProductOrders(enqPrdId: any, appContext: any, success: any, error: any) {
    return get(`/order/getproductorders?enqPrdId=${enqPrdId}`, appContext, success, error);
}

export function getQualityParameter(qualityModel: any, appContext: any, success: any, error: any) {
    return post(`/order/getqualityparam`, qualityModel, appContext, success, error);
}

export function getQualityStatus(qualityModel: any, appContext: any, success: any, error: any) {
    return post(`/order/getqualitystatus`, qualityModel, appContext, success, error);
}

export function saveQualityParam(qualityModel: any, appContext: any, success: any, error: any) {
    return post(`/order/savequalityparam`, qualityModel, appContext, success, error);
}

export function saveQualityStatus(qualityModel: any, appContext: any, success: any, error: any) {
    return post(`/order/savequalitystatus`, qualityModel, appContext, success, error);
}

export function getPOJOById(id: any, appContext: any, success: any, error: any) {
    return get(`/order/pojo/findbyid?pojoId=${id}`, appContext, success, error);
}

export function deletePojo(id: any, appContext: any, success: any, error: any) {
    return remove(`/order/pojo?pojoId=${id}`, appContext, success, error);
}

export function deleteChallan(id: any, appContext: any, success: any, error: any) {
    return remove(`/order/challan?challanId=${id}`, appContext, success, error);
}

export function getPOJOByLinkId(linkId: any, appContext: any, success: any, error: any) {
    return get(`/order/pojo/findbylinkid?linkId=${linkId}`, appContext, success, error);
}

export function savePOJO(pojoModel: any, appContext: any, success: any, error: any) {
    return post(`/order/pojo`, pojoModel, appContext, success, error);
}

export function saveChallan(challanModel: any, appContext: any, success: any, error: any) {
    return post(`/order/challan`, challanModel, appContext, success, error);
}

export function getChallanById(id: any, appContext: any, success: any, error: any) {
    return get(`/order/challan/findbyid?challanId=${id}`, appContext, success, error);
}

export function createChallanFromPOJOId(id: any, stock: any, appContext: any, success: any, error: any) {
    return post(`/order/challan/createfrompojoid?pojoId=${id}`, stock, appContext, success, error);
}

export function getChallanByPOJOId(id: any, appContext: any, success: any, error: any) {
    return get(`/order/challan/findbypojoid?pojoId=${id}`, appContext, success, error);
}

export function getNonPojoChallan(orderId: any, productId: any, appContext: any, success: any, error: any) {
    return get(`/order/challan/nonpojo?orderId=${orderId}&productId=${productId}`, appContext, success, error);
}

export function getAllPojoChallan(searchData: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return post(`/order/pojochallan?page=${pageNumber}&size=${pageSize}`, searchData, appContext, success, error);
}

export function getAllPojo(orderId: any, appContext: any, success: any, error: any) {
    return get(`/order/pojo?orderId=${orderId}`, appContext, success, error);
}

export function getBomSale(orderId: any, appContext: any, success: any, error: any) {
    return get(`/order/bom/sale?orderId=${orderId}`, appContext, success, error);
}

export function saveMasterPojo(data: any, appContext: any, success: any, error: any) {
    return post(`/order/pojo/master`, data, appContext, success, error);
}

export function getPojoByMasterCode(masterCode: any, appContext: any, success: any, error: any) {
    return get(`/order/pojo/master?masterCode=${masterCode}`, appContext, success, error);
}

export function mergePojo(pojo: any, appContext: any, success: any, error: any) {
    return post(`/order/pojo/merge`, pojo, appContext, success, error);
}

export function searchOrderProduct(orderCode: any, inputCode: any, appContext: any, success: any, error: any) {
    return get(`/order/findbyordercode?orderCode=${orderCode}&inputCode=${inputCode}`, appContext, success, error);
}

export function getPojoPrint(pojoId: any, appContext: any, success: any, error: any) {
    return get(`/order/pojo/print?pojoId=${pojoId}`, appContext, success, error);
}

export function getMasterPojoPrint(code: any, appContext: any, success: any, error: any) {
    return get(`/order/pojo/master/print?code=${code}`, appContext, success, error);
}

export function getChallanPrint(challanId: any, appContext: any, success: any, error: any) {
    return get(`/order/challan/print?challanId=${challanId}`, appContext, success, error);
}

export function getChallanDetail(detailId: any, appContext: any, success: any, error: any) {
    return get(`/order/challan/detail?detailId=${detailId}`, appContext, success, error);
}

export function updateAvailableQty(data: any, appContext: any, success: any, error: any) {
    return post(`/order/challan/availableqty`, data, appContext, success, error);
}

export function saveChallanPrint(printData: any, appContext: any, success: any, error: any) {
    return post(`/order/challan/print`, printData, appContext, success, error);
}